import React, { useMemo, useState } from "react";
import { CALC_TYPES } from "../mock";

const Calculator = () => {
  const [typeId, setTypeId] = useState("byt");
  const [area, setArea] = useState("");
  const [level, setLevel] = useState("standard");

  const type = CALC_TYPES.find((t) => t.id === typeId);

  const price = useMemo(() => {
    const a = parseFloat(area);
    if (!a || a <= 0) return null;
    const perM2 = level === "standard" ? type.standard : type.nadstandard;
    const base = a * perM2;
    return {
      low: Math.round(base * 0.85),
      high: Math.round(base * 1.15),
    };
  }, [area, level, type]);

  const formatted = (n) => new Intl.NumberFormat("cs-CZ").format(n) + " Kč";

  const pillBase =
    "py-3 rounded-none text-[14px] font-semibold border transition-all";
  const active = "bg-[#1a1a1a] text-white border-[#1a1a1a]";
  const inactive =
    "bg-white text-[#1b2b45] border-[#e0d8ca] hover:border-[#c79a5b]";

  return (
    <section id="kalkulacka" className="py-20 md:py-28 bg-[#f7f4ee]">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <div className="text-center">
          <span className="eyebrow-line">Orientační cena</span>
          <h2 className="font-heading mt-5 text-[30px] sm:text-[38px] md:text-[52px] font-bold text-[#1b2b45] leading-tight">
            Kalkulačka rekonstrukce
          </h2>
        </div>

        <div className="mt-12 bg-white rounded-none border border-[#efe9df] p-7 md:p-10">
          <label className="block text-[12px] font-bold uppercase tracking-[0.14em] text-[#8a92a3] mb-3">
            Typ rekonstrukce
          </label>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {CALC_TYPES.map((t) => (
              <button
                key={t.id}
                onClick={() => setTypeId(t.id)}
                className={`${pillBase} ${typeId === t.id ? active : inactive}`}
              >
                {t.label}
              </button>
            ))}
          </div>
          <p className="mt-3 text-[12.5px] text-[#8a92a3]">{type.note}</p>

          <label className="block text-[12px] font-bold uppercase tracking-[0.14em] text-[#8a92a3] mt-8 mb-3">
            {type.areaLabel}
          </label>
          <input
            type="number"
            min="0"
            value={area}
            onChange={(e) => setArea(e.target.value)}
            placeholder={type.placeholder}
            className="w-full border-0 border-b-2 border-[#e0d8ca] bg-transparent px-1 py-2 text-[22px] font-medium text-[#1b2b45] outline-none focus:border-[#c79a5b] transition placeholder:text-[#c9c2b4]"
          />

          <label className="block text-[12px] font-bold uppercase tracking-[0.14em] text-[#8a92a3] mt-8 mb-3">
            Provedení
          </label>
          <div className="grid grid-cols-2 gap-3 max-w-sm">
            {[
              { id: "standard", label: "Standard" },
              { id: "nadstandard", label: "Nadstandard" },
            ].map((l) => (
              <button
                key={l.id}
                onClick={() => setLevel(l.id)}
                className={`${pillBase} ${level === l.id ? active : inactive}`}
              >
                {l.label}
              </button>
            ))}
          </div>

          <div className="mt-9 pt-8 border-t border-[#efe9df]">
            <p className="text-[12px] font-bold uppercase tracking-[0.14em] text-[#8a92a3]">
              Orientační cena
            </p>
            <p className="font-heading mt-2 text-[24px] sm:text-[34px] md:text-[40px] font-bold text-[#1b2b45] leading-tight">
              {price
                ? `${formatted(price.low)} – ${formatted(price.high)}`
                : "Zadejte plochu pro výpočet"}
            </p>
            <p className="mt-2 text-[13px] text-[#8a92a3]">
              {price
                ? `${type.label} · ${area} ${type.unit} · ${
                    level === "standard" ? "Standard" : "Nadstandard"
                  } · rozptyl ±15 %`
                : "Orientační odhad. Přesnou cenu stanovíme po konzultaci a zaměření."}
            </p>

            <a
              href="#kontakt"
              className="font-serif-nav mt-6 w-full inline-flex items-center justify-center gap-2 bg-[#c79a5b] hover:bg-[#b3854a] text-[#1b2b45] text-[15px] font-bold uppercase tracking-[0.08em] px-6 py-4 rounded-none transition-colors"
            >
              Nezávazná poptávka
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Calculator;
